<template>
  <v-off-canvas
    id="user-filters-offcanvas"
    :backdrop-static="false"
    offcanvas-class="offcanvas-end"
    @closed="$emit('closed')"
  >
    <resizable-container>
      <off-canvas-header>
        <h5 class="offcanvas-title">{{ $t("general.shared.filters") }}</h5>
      </off-canvas-header>

      <off-canvas-body>
        <v-form id="user-filter-status-select" label="Case" form-type="outline">
          <v-select
            v-model="filterCaseId"
            :clearable="false"
            :options="caseList"
            label="name"
            :reduce="(item) => item.id"
            :filterable="false"
            @search="onSearchCase"
            @option:selected="
              $emit('update:case-id', filterCaseId);
              $emit('selected');
            "
          >
            <template v-slot:no-options>
              <div class="my-4">{{ $t("general.vueSelect.noOptions") }}</div>
            </template>
          </v-select>
        </v-form>
      </off-canvas-body>
    </resizable-container>
  </v-off-canvas>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import vSelect from "vue-select";
import api from "@/api";
import { VForm } from "@uniqoders/form";
import VOffCanvas from "@/components/vendor/basic/offcanvas/VOffCanvas.vue";
import OffCanvasHeader from "@/components/vendor/basic/offcanvas/OffCanvasHeader.vue";
import OffCanvasBody from "@/components/vendor/basic/offcanvas/OffCanvasBody.vue";
import useConcepts from "@/helpers/Concepts";
import ResizableContainer from "@/components/resizablecontainer/ResizableContainer.vue";

export default defineComponent({
  name: "TheCasePaxDetailOffcanvas",
  components: {
    OffCanvasBody,
    OffCanvasHeader,
    VOffCanvas,
    vSelect,
    VForm,
    ResizableContainer,
  },
  emits: ["closed", "selected", "update:case-id"],
  props: {
    caseId: {
      type: Number,
      default: null,
    },
    agency: String,
  },
  setup() {
    return {
      ...useConcepts(),
    };
  },
  data() {
    return {
      filterCaseId: this.caseId,
      caseList: [],
      searchTimer: null as any,
    };
  },
  watch: {
    caseId(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.filterCaseId = this.caseId;
      }
    },
  },
  methods: {
    async fetchCaseList(search = "") {
      const params: any = {};

      if (search && search.trim()) {
        params.name = search.trim();
      }
      const response = await api.case.dropdown(this.agency, params);
      this.caseList = response?.content || [];
    },
    onSearchCase(search: string) {
      clearTimeout(this.searchTimer);

      this.searchTimer = setTimeout(() => {
        this.fetchCaseList(search);
      }, 400); // debounce
    },
  },
  mounted() {
    this.fetchCaseList();
  },
});
</script>
